module.exports = __webpack_public_path__ + "img/8400.fa544145.jpg";